export default "/list/static/images/Orbitz.svg";